module.exports = __webpack_public_path__ + "img/page-bg-soft.90d79948.png";